


























import Vue from 'vue'
import store from '../../store'
import { getCard } from '../../assets/utility'
import { DeckInfo, CardType } from '../../models'
import { firestore } from 'firebase'
import Card from '../Library/Card.vue'
import GoToButton from '../Buttons/GoToButton.vue'
import LoginModal from '../Modals/LoginModal.vue'
import Logout from '../Logout.vue'
require('typeface-lobster')
export default Vue.extend({
  name: 'Share',
  components: {
    // Decks,
    Card,
    GoToButton,
    Logout,
    LoginModal
  },
  created () {

  },
  mounted () {
    this.getCard()
  },
  data () {
    return {
      card: new CardType({}),
      deckId: this.$route.params.deckId,
      cardId: this.$route.params.cardId
    }
  },
  computed: {
    askLogin () {
      return store.state.askLogin
    }
  },
  methods: {
    goTo (place:string) {
      switch (place) {
        case 'library':
          this.$router.push({ 'name': 'library' })
          break
        case 'main':
          this.$router.push({ 'name': 'main' })
          break
      }
    },
    async getCard () {
      let vm = this
      try {
        let doc = await getCard(this.deckId, this.cardId)
        if (doc.exists) {
          // console.log('TCL: getCard -> doc', doc)
          vm.card = new CardType({ ...doc.data(), id: doc.id })
          // console.log(vm.card.toString())
        } else {
          this.$toasted.show('Card does not exists!', { type: 'error', duration: 3000 })
        }
      } catch (err) {
        console.log('TCL: getCard -> err', err)
      }
    },
    showLogin () {
      this.$modal.show('login')
    }
  }
})

